let KeyCode;
(function(KeyCode2) {
  KeyCode2["ArrowLeft"] = "ArrowLeft";
  KeyCode2["ArrowRight"] = "ArrowRight";
  KeyCode2["ArrowUp"] = "ArrowUp";
  KeyCode2["ArrowDown"] = "ArrowDown";
  KeyCode2["Home"] = "Home";
  KeyCode2["End"] = "End";
  KeyCode2["PageUp"] = "PageUp";
  KeyCode2["PageDown"] = "PageDown";
  KeyCode2["Enter"] = "Enter";
})(KeyCode || (KeyCode = {}));
export {
  KeyCode
};
